import { render } from "./CollectionDetail.vue?vue&type=template&id=f681eaec&scoped=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=js"
export * from "./CollectionDetail.vue?vue&type=script&lang=js"

import "./CollectionDetail.vue?vue&type=style&index=0&id=f681eaec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f681eaec"]])

export default __exports__